import { CloseButton, PeriodPickerContainer, ValueView } from '@/components';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { CreateElement, VNode } from 'vue';
import { IAboutApartmentData, IAboutApartmentTranslation } from '@/types';
import { createSimpleTransition } from 'vuetify/lib/components/transitions/createTransition';
import { MapGetters } from '@/utils';
import './style.styl';

const rentTransition = createSimpleTransition('rent-transition');
@Component({
  name: 'RentBlock',
})
export default class RentBlock extends Vue {
  @Prop({type: Object, default: () => {}}) public readonly translation!: IAboutApartmentTranslation['rent_block'];
  @Prop({type: Object, default: () => {}}) public readonly data!: IAboutApartmentData;
  @Prop({type: [Number, String], default: 390}) public readonly width!: number | string;
  @Prop({type: Boolean, default: false}) public readonly mobile!: boolean;
  @Prop({type: String, default: ''}) public readonly startDate!: string;
  @Prop({type: Boolean, default: false}) public readonly readonly!: boolean;
  @Prop({type: Boolean, default: false}) public readonly disabledButton!: boolean;
  @Prop({type: String, default: ''}) public readonly error!: string;

  @MapGetters(['logged'], 'user')

  public toggle: boolean = false;

  public toggleWindow() {
    const app = document.getElementById('app');
    if (app && this.mobile) {
      if (!this.toggle) {
        this.toggle = true;
        setTimeout(() => {
          app.style.overflow = 'auto';
          app.style.height = '100vh';
        }, 500);
      } else {
        app.style.overflow = '';
        app.style.height = '';
        this.toggle = false;
      }
    }
  }

  public get componentWidth() {
    if (typeof this.width === 'string') {
      return this.width;
    } else {
      return `${this.width}px`;
    }
  }

  private render(createElement: CreateElement): VNode {
    const price = !!this.data.price && createElement('h4', `${this.data.price} ${this.data.currency_per_month}`);
    const line = createElement('div', { class: 'rent-line'});
    const period = createElement('div', { class: 'flex-between' }, [
      createElement(ValueView, {
        props: {
          vertical: true,
          name: this.translation.start_date,
          value: this.$dayjs(this.startDate).format('DD.MM.YYYY'),
        },
      }),
      createElement('div', { class: 'rent-vertical-line'}),
      createElement(PeriodPickerContainer, {
        props: {
          readonly: this.readonly,
          maxDate: this.data.end,
        },
      }),
    ]);

    const guarantee: VNode = createElement(ValueView, {
      props: {
        name: this.translation.guarantee_payment,
        value: `${(this as any).data.price_guarantee_payment} ${this.data.currency}`,
      },
    });
    const rentPerFirstMonth: VNode = createElement('div', {
      class: ['guarantee-text'],
    },
        `${(this as any).translation.guarantee_promo}`,
        );

    const total: VNode = createElement(ValueView, {
      props: {
        name: this.translation.total,
        value: `${(this as any).data.price_guarantee_payment} ${this.data.currency}`,
      },
    });
    const button: any = !!this.translation.button_name && createElement('button', {
        attrs: {
          disabled: this.disabledButton,
        },
        on: {
          click: () => {
            (this as any).logged
              ? this.$emit('nextStep')
              : this.$router.pushAndSave({name: 'login'});
            this.toggleWindow();
          },
        },
        class: 'orange-big-button',
      }, `${(this as any).data.reservation
            ? (this as any).translation.button_continue_name
            : this.translation.button_name}`);

    const errorMessage: VNode = createElement('span',
      {
        class: 'error',
      },
      this.error);

    const hint: any = !!this.translation.hint_promo && createElement('p', {
      class: 'p7',
    }, `${this.translation.hint_promo}`);

    const close: VNode = createElement('div',
      {
        class: 'rent-close',
      },
      [
        createElement(CloseButton, {
          nativeOn: {
            click: () => this.toggleWindow(),
          },
        }),
    ]);

    const big: VNode = createElement('div', {
      attrs: {
        id: 'rent-block',
      },
      class: ['flex-column', 'flex-left', this.mobile && 'mobile'],
    }, [
      this.mobile && close,
      price,
      line,
      period,
      line,
      guarantee,
      rentPerFirstMonth,
      line,
      total,
      button,
      errorMessage,
      hint,
    ]);

    const smallPrice: VNode = createElement('span', {
      class: 'h7',
    }, `${this.data.price} ${this.data.currency_per_month}`);

    const smallButton: VNode = createElement('button', {
      class: 'orange-little-button',
      on: {
        click: () => this.toggleWindow(),
      },
    }, `${this.translation.button_name}`);

    const small: any = !!this.translation.button_name && createElement(rentTransition, [
      createElement('div', {
        class: ['rent-block-small'],
      }, [
        smallPrice,
        smallButton,
      ]),
    ]);
// TODO nice animation
    return createElement('span', {
      class: ['rent-block-wrapper', this.mobile && 'mobile'],
      style: {
        width: !this.mobile && `${this.componentWidth}px`,
      },
    }, [
      this.mobile ? this.toggle ? big : small : big,
    ]);
  }
}
